export default __webpack_public_path__ + "static/media/s-logo.d637f38e.png";